/**
 * Visitor tracking for Gravity Forms' {user_referrer} and {user_path}
 * merge tags (see includes/gravity-forms.php, which reads these cookies
 * when an entry is saved).
 *
 * - ll_referrer: the first off-site referrer, kept for a day from the landing.
 * - ll_path: every page viewed, newline-separated, kept for a day from the
 *   last view. When it outgrows the cap the oldest page after the landing
 *   page is dropped, so both ends survive.
 */
(() => {
	if (document.body.classList.contains('error404')) return;

	const read = (name) => {
		const match = document.cookie.match(`(?:^|; )${name}=([^;]*)`);
		return match ? decodeURIComponent(match[1]) : '';
	};
	const write = (name, value) => {
		const secure = location.protocol === 'https:' ? '; Secure' : '';
		document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=86400; SameSite=Lax${secure}`;
	};

	try {
		if (!read('ll_referrer') && document.referrer && new URL(document.referrer).host !== location.host) {
			write('ll_referrer', document.referrer);
		}
	} catch (e) {}

	const path = read('ll_path').split('\n').filter(Boolean);
	const here = location.pathname + location.search;

	if (path[path.length - 1] !== here) path.push(here);
	while (path.length > 2 && (path.length > 25 || encodeURIComponent(path.join('\n')).length > 3000)) {
		path.splice(1, 1);
	}
	write('ll_path', path.join('\n'));
})();
